import type { ISerialize } from '@/objects/ISerialize';
import { RaceContestantPoints } from './RaceContestantPoints';
import { formatDateIso } from '@/utilities/dateutils';

export class RaceContestantWithPoints implements ISerialize {
    public ID: number;

    public ContestantID: number;

    public Points: RaceContestantPoints[];

    public RaceID: number;

    public StartTime: Date | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        ContestantID?: number;
        Points?: RaceContestantPoints[];
        RaceID?: number;
        StartTime?: Date | null;
    }) {
        this.ID = values.ID ?? 0;

        this.ContestantID = values.ContestantID ?? 0;

        this.Points = values.Points ?? [];

        this.RaceID = values.RaceID ?? 0;

        this.StartTime = values.StartTime ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"Points": [ ${this.Points.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            ',' +
            `"StartTime": ${this.StartTime ? '"' + formatDateIso(this.StartTime) + '"' : null}` +
            '}'
        );
    }

    /**
     * Creates an instance of RaceContestantWithPoints from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        ContestantID?: number;
        Points?: RaceContestantPoints[];
        RaceID?: number;
        StartTime?: Date | null;
    }): RaceContestantWithPoints {
        return new RaceContestantWithPoints(values);
    }

    public static _FromServerJson(json: any): RaceContestantWithPoints {
        return new RaceContestantWithPoints({
            ID: json.ID,
            ContestantID: json.ContestantID,
            Points: json.Points?.map((x: any) => RaceContestantPoints._FromServerJson(x)),
            RaceID: json.RaceID,
            StartTime: json.StartTime ? (json.StartTime instanceof Date ? json.StartTime : new Date(json.StartTime)) : null,
        });
    }

    /**
     * Creates an instance of RaceContestantWithPoints from another instance of RaceContestantWithPoints.
     * @param other The RaceContestantWithPoints you want to clone
     * @returns A cloned RaceContestantWithPoints
     */
    public static FromOther(other: RaceContestantWithPoints): RaceContestantWithPoints {
        return RaceContestantWithPoints._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantWithPoints.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantWithPoints';
}
